import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia';
import CardParametrosConsulta from './components/consulta/CardParametrosConsulta.vue';
import ResultadoConsulta from './components/consulta/ResultadoConsulta.vue';
import { ConsultaJurisprudenciaSelecionadaStore } from './store/ConsultaJurisprudenciaSelecionadaStore';
import HeaderCustom from '../components/HeaderCustom.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ConsultaJurisprudenciaSelecionada',
  setup(__props) {

const store = ConsultaJurisprudenciaSelecionadaStore();

const { totalElementos } = storeToRefs(store);

return { __sfc: true,store, totalElementos, CardParametrosConsulta, ResultadoConsulta, HeaderCustom }
}

})